import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from '../Service/Api';
import LazyLoad from 'react-lazyload';

const PrincipalMessage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);

  const emptyArray = [
    { description: "Education is the most powerful and effective medium of social transformation and national integration. The Sacred Heart Convent School, Jagraon has made great contribution towards the accomplishment of this noble aim. Any educational institution stands for inculcating of education that is total and integral. The primary goal of an educational institution is the formation rather than academic studies and imparting information to the students. Every student needs to be helped individually in his/her efforts in self-formation, to play one’s role in life and to build a healthy society. This automatically leads to the progress of the persons, family society and nation. The end of education is to build character and to help to develop good citizens of tomorrow.Future of the nation depends on their knowledge, their character and their skills. Character building begins at home and continues in school. Education is a joint venture and it calls for concerted efforts and active participation of all concerned – the parents, teachers, students, educational agency and the state. The school and the home, teachers and parents are equal partners in this endeavor. May we the parents, teachers and the citizens at large accept the challenges and let our educational effort fulfill our essential mission for the youth and the nation. May the Sacred Heart of Jesus bless us all with His Love, Peace and Joy.", attachments: "principal.jpg", name: "Sr. Ancy Joseph" },   
  ];

  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
        <li><Link to="/home"> Home</Link> </li>
          <li>About Us</li>
          <li> Principal's Message</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Principal's Message</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {data.length > 0 ? (
                data.filter((div) => div.category === "Principal").map((item, index) => (
                  <div key={index}>
                    <div className="msgbox">
                      <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`} alt="" className="img-fluid"/></LazyLoad>
                    </div>
                    <p>{item.message}</p>
                    <p className="name">{item.name} <span>Principal</span></p>
                  </div>
                ))
              ) : (
                emptyArray.map((item, index) => (
                  <div key={index}>
                    <div className="msgbox">
                      <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`} alt="" className="img-fluid"/></LazyLoad>
                    </div>
                    <p>{item.description}</p>
                    <p className="name">{item.name} <span>Principal</span></p>
                  </div>
                ))
              )}
            </div>
          </div> 
        </div>
      </div>
    </>
  );
}

export default PrincipalMessage;
